import { render } from "./SearchModalPopularSuggestion.vue?vue&type=template&id=8ebac91a"
import script from "./SearchModalPopularSuggestion.vue?vue&type=script&lang=js"
export * from "./SearchModalPopularSuggestion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__